module.exports = __webpack_public_path__ + "static/media/s_big_02.4ce1aa90.png";